<template>
    <div class="client-single client-view-project">
        <div class="m-content">
xxx
        </div>
    </div>

</template>
<script>

    export default {
        name: 'client-view-project',
        props: {
            project: Object
        },
        data() {
            return {
                editClientDataToggle: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        },
        mounted() {

        },
        watch: {

        },
        methods: {

        }
    }
</script>
